module.exports = __webpack_public_path__ + "img/cns.6dfe076f.png";